// peindentSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { format } from 'date-fns';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchIndentsAsync = createAsyncThunk(
  'indent/fetchIndents',
  async ({ role, enteredBy }) => {
    const endpoint = role === "admin" 
      ? `${API_BASE_URL}/adminpage/indent`
      : `${API_BASE_URL}/indent/indent`;
      
    const response = await axios.get(endpoint, {
      params: { ...(role !== "admin" && { ProjectIncharge: enteredBy }) },
    });
    return response.data;
  }
);

export const fetchDropdownDataAsync = createAsyncThunk(
  'indent/fetchDropdownData',
  async () => {
    const [usersRes, projectsRes, stagesRes, typesRes] = await Promise.all([
      axios.get(`${API_BASE_URL}/dropdown/users`),
      axios.get(`${API_BASE_URL}/dropdown/mprojects`),
      axios.get(`${API_BASE_URL}/dropdown/mstages`),
      axios.get(`${API_BASE_URL}/dropdown/mindenttypes`),
    ]);

    return {
      users: usersRes.data.map(user => ({ id: user.UserID, name: user.Username })),
      projects: projectsRes.data.map(project => ({ id: project.ProjectID, name: project.ProjectName })),
      stages: stagesRes.data.map(stage => ({ id: stage.StageID, name: stage.StageName })),
      types: typesRes.data.map(type => ({ id: type.TypeID, name: type.TypeName })),
    };
  }
);

const peindentSlice = createSlice({
  name: 'peindent',
  initialState: {
    indents: [],
    filteredIndents: [],
    dropdownData: {
      users: [],
      projects: [],
      stages: [],
      types: [],
    },
    loading: {
      indents: false,
      dropdown: false,
    },
    error: null,
  },
  reducers: {
    setFilteredIndents: (state, action) => {
      state.filteredIndents = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIndentsAsync.pending, (state) => {
        state.loading.indents = true;
      })
      .addCase(fetchIndentsAsync.fulfilled, (state, action) => {
        state.loading.indents = false;
        const formattedIndents = action.payload.map(indent => ({
          ...indent,
          L1: indent.L1 ? "Approved" : "Pending",
          L2: indent.L2 ? "Approved" : "Pending",
          PO: indent.PO ? "Approved" : "Pending",
          PH: indent.PH ? "Approved" : "Pending",
          IR: indent.IR ? "Approved" : "Pending",
          SH: indent.SH ? "Approved" : "Pending",
          // Keep the dates as they come from the server since they're already formatted
          CreationDate: indent.CreationDate || "N/A",
          PEApprovalDate: indent.PEApprovalDate || "N/A",
          L1ApprovedDate: indent.L1ApprovedDate || "N/A",
          L2ApprovalDate: indent.L2ApprovalDate || "N/A"
        }));
        state.indents = formattedIndents;
        state.filteredIndents = formattedIndents;
      })
      .addCase(fetchIndentsAsync.rejected, (state, action) => {
        state.loading.indents = false;
        state.error = action.error.message;
      })
      .addCase(fetchDropdownDataAsync.pending, (state) => {
        state.loading.dropdown = true;
      })
      .addCase(fetchDropdownDataAsync.fulfilled, (state, action) => {
        state.loading.dropdown = false;
        state.dropdownData = action.payload;
      })
      .addCase(fetchDropdownDataAsync.rejected, (state, action) => {
        state.loading.dropdown = false;
        state.error = action.error.message;
      });
  },
});

export const { setFilteredIndents } = peindentSlice.actions;
export default peindentSlice.reducer;